import React from 'react';

const SalesInvoiceFormat8 = ({
    data,
    invoiceData,
    selectedPaymentType = 'Debit',
    selectedInvoiceType = 'TAX INVOICE',
    selectedCopyType = 'Original',
    getImageUrl
}) => {
    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };

    const itemChunks = invoiceData.items && invoiceData.items.length > 0
        ? chunkArray(invoiceData.items, 15)
        : [[]];

    return (
        <div className="invoice-pages-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontFamily: '"Arial", "Helvetica", sans-serif', color: '#000' }}>
            {itemChunks.map((chunk, pageIndex) => {
                const company = data?.Company || data?.companyId || data?.company || {};

                return (
                    <div className="invoice-box" key={pageIndex} style={{ border: '1.5px solid #000', color: '#000', fontSize: '10px', background: '#fff', width: '800px', margin: '0 auto', boxSizing: 'border-box', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                        <div className="header-image-container" style={{ padding: 0 }}>
                            {/* Company Name Header */}
                            <div style={{ backgroundColor: '#d1d5db', borderBottom: '1.5px solid #000', padding: '10px', textAlign: 'center' }}>
                                <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                    {data?.invoiceCompanyName || data?.invoice_company_name || data?.companyName || company?.company_name || 'COMPANY NAME'}
                                </h1>
                            </div>

                            {/* Company Address Row */}
                            <div style={{ padding: '5px 10px', textAlign: 'center', fontSize: '9px', fontWeight: 'bold' }}>
                                <div style={{ textTransform: 'uppercase', marginBottom: '4px' }}>
                                    {data?.invoiceCompanyAddress || data?.invoice_company_address || data?.companyAddress || company?.company_address || ''}
                                    {company?.companyCity ? `, ${company.companyCity}` : ''}
                                    {company?.companyState ? `, ${company.companyState}` : ''}
                                    {company?.companyPinCode ? `, PIN: ${company.companyPinCode}` : ''}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>E-mail : {company?.company_email || company?.companyEmail || ''}</span>
                                    <span>Mo : +91 {company?.company_mobile_1 || company?.companyMobileNumber_1 || ''}</span>
                                </div>
                            </div>
                        </div>

                        {/* Invoice Type Row */}
                        <div style={{ display: 'flex', borderBottom: '1.5px solid #000', fontWeight: 'bold', fontSize: '10px', padding: '4px 10px' }}>
                            <div style={{ flex: 1 }}>{selectedPaymentType.toUpperCase()}</div>
                            <div style={{ flex: 2, textAlign: 'center' }}>{selectedInvoiceType.toUpperCase()}</div>
                            <div style={{ flex: 1, textAlign: 'right' }}>{selectedCopyType.toUpperCase()}</div>
                        </div>

                        {/* Meta Info Row */}
                        <div style={{ display: 'flex', borderBottom: '1.5px solid #000' }}>
                            {/* Left Side: Buyer */}
                            <div style={{ flex: '1.1', borderRight: '1.5px solid #000', padding: '5px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '80px 10px 1fr', rowGap: '4px', fontSize: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>M/s.</span>
                                    <span style={{ fontWeight: 'bold' }}>:</span>
                                    <div>
                                        <strong style={{ fontSize: '12px', textTransform: 'uppercase' }}>{invoiceData.buyer.name}</strong>
                                        <div style={{ marginTop: '4px', textTransform: 'uppercase', lineHeight: '1.3' }}>
                                            {invoiceData.buyer.address}
                                            {invoiceData.buyer.cityState && <div>{invoiceData.buyer.cityState}</div>}
                                        </div>
                                    </div>
                                    <span style={{ fontWeight: 'bold' }}>Place of Supply</span>
                                    <span style={{ fontWeight: 'bold' }}>:</span>
                                    <span style={{ textTransform: 'uppercase' }}>{invoiceData.buyer.placeOfSupply}</span>

                                    <span style={{ fontWeight: 'bold' }}>PAN No.</span>
                                    <span style={{ fontWeight: 'bold' }}>:</span>
                                    <span style={{ textTransform: 'uppercase' }}>{invoiceData.buyer.pan}</span>

                                    <span style={{ fontWeight: 'bold' }}>GSTIN No.</span>
                                    <span style={{ fontWeight: 'bold' }}>:</span>
                                    <span style={{ textTransform: 'uppercase' }}>{invoiceData.buyer.gstin}</span>
                                </div>
                            </div>

                            {/* Right Side: Shipping & Invoice Meta */}
                            <div style={{ flex: '0.9', padding: '5px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '90px 10px 1fr', rowGap: '4px', fontSize: '10px', fontWeight: 'bold' }}>
                                    <span>Invoice No.</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase' }}>{invoiceData.invoiceNo}</span>

                                    <span>Date</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase' }}>{invoiceData.invoiceDate}</span>

                                    <span style={{ marginTop: '4px' }}>Transporter</span>
                                    <span style={{ marginTop: '4px' }}>:</span>
                                    <span style={{ marginTop: '4px', textTransform: 'uppercase', fontWeight: 'normal' }}>{invoiceData.transporter}</span>

                                    <span>L.R.No.</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase', fontWeight: 'normal' }}>{invoiceData.lrNo}</span>

                                    <span>Vehicle No.</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase', fontWeight: 'normal' }}>{invoiceData.vehicleNo}</span>

                                    <span>Container No.</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase', fontWeight: 'normal' }}>{invoiceData.containerNo}</span>

                                    <span>Seal No.</span>
                                    <span>:</span>
                                    <span style={{ textTransform: 'uppercase', fontWeight: 'normal' }}>{invoiceData.sealNo}</span>
                                </div>
                            </div>
                        </div>

                        {/* Products Grid Headers */}
                        <div style={{ display: 'grid', gridTemplateColumns: '40px 1fr 70px 80px 70px 60px 70px 60px 90px', borderBottom: '1.5px solid #000', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#f9fafb' }}>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>SrNo</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>Product Name</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>Size</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>Grade</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>HSN/SAC</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>Qty</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>Rate</div>
                            <div style={{ borderRight: '1.5px solid #000', padding: '4px' }}>{invoiceData.totals.isLocal ? 'GST %' : 'IGST %'}</div>
                            <div style={{ padding: '4px' }}>Amount</div>
                        </div>

                        {/* Items Content */}
                        <div className="invoice-content-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '300px' }}>
                            {chunk.map((item, i) => {
                                const gstRate = invoiceData.totals.isLocal ? (parseFloat(invoiceData.totals.tax1Rate) + parseFloat(invoiceData.totals.tax2Rate)) : (parseFloat(invoiceData.totals.tax1Rate) + parseFloat(invoiceData.totals.tax2Rate));
                                return (
                                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '40px 1fr 70px 80px 70px 60px 70px 60px 90px', minHeight: '22px', borderBottom: '1.5px solid #000' }}>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px' }}>{item.srNo}</div>
                                        <div style={{ borderRight: '1.5px solid #000', padding: '4px', textAlign: 'left', fontWeight: 'normal', textTransform: 'uppercase' }}>
                                            {item.product}
                                            {item.category && <span style={{ marginLeft: '4px', fontSize: '9px', color: '#555' }}>({item.category})</span>}
                                        </div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px', textTransform: 'uppercase' }}>{item.model}</div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px', textTransform: 'uppercase' }}>{item.grade}</div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px', textTransform: 'uppercase' }}>{item.hsn}</div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px' }}>{item.qty}</div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'right', padding: '4px' }}>{item.rate}</div>
                                        <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px' }}>{gstRate ? gstRate.toFixed(2) : '18.00'}</div>
                                        <div style={{ textAlign: 'right', padding: '4px', fontWeight: 'bold' }}>{item.amount}</div>
                                    </div>
                                )
                            })}
                            {/* Filler row for continuous vertical lines */}
                            <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '40px 1fr 70px 80px 70px 60px 70px 60px 90px' }}>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div style={{ borderRight: '1.5px solid #000' }}></div>
                                <div></div>
                            </div>
                        </div>

                        {/* Sub Total Row */}
                        <div style={{ display: 'grid', gridTemplateColumns: '40px 1fr 70px 80px 70px 60px 70px 60px 90px', borderTop: '1.5px solid #000', borderBottom: '1.5px solid #000', fontWeight: 'bold' }}>
                            <div style={{ gridColumn: 'span 4', borderRight: '1.5px solid #000', padding: '4px 5px', fontSize: '9px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div>PAN No.: {company?.company_pan_card_number || company?.companyPanCardNumber || ''}</div>
                                <div>GSTIN No.: {company?.company_gst_number || company?.companyGstNumber || ''}</div>
                            </div>
                            <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Total</div>
                            <div style={{ borderRight: '1.5px solid #000', textAlign: 'center', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{invoiceData.totals.qty}</div>
                            <div style={{ gridColumn: 'span 2', borderRight: '1.5px solid #000', textAlign: 'left', padding: '4px 10px', display: 'flex', alignItems: 'center' }}>Sub Total</div>
                            <div style={{ textAlign: 'right', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>{invoiceData.totals.subTotal}</div>
                        </div>

                        {/* Footer Section */}
                        <div style={{ display: 'flex', borderBottom: '1.5px solid #000' }}>
                            {/* Left Half */}
                            <div style={{ flex: 1, borderRight: '1.5px solid #000', display: 'flex', flexDirection: 'column' }}>
                                {/* Bank Details */}
                                <div style={{ padding: '5px', borderBottom: '1.5px solid #000' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '120px 10px 1fr', rowGap: '4px', fontSize: '10px' }}>
                                        <span style={{ fontWeight: 'bold' }}>Bank Name</span>
                                        <span style={{ fontWeight: 'bold' }}>:</span>
                                        <span style={{ textTransform: 'uppercase' }}>{invoiceData.bank.name}</span>

                                        <span style={{ fontWeight: 'bold' }}>Bank A/c. No.</span>
                                        <span style={{ fontWeight: 'bold' }}>:</span>
                                        <span style={{ textTransform: 'uppercase' }}>{invoiceData.bank.accountNumber}</span>

                                        <span style={{ fontWeight: 'bold' }}>RTGS/IFSC Code</span>
                                        <span style={{ fontWeight: 'bold' }}>:</span>
                                        <span style={{ textTransform: 'uppercase' }}>{invoiceData.bank.ifsc}</span>
                                    </div>
                                </div>
                                {/* Words */}
                                <div style={{ padding: '5px', borderBottom: '1.5px solid #000', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <div style={{ display: 'flex', marginBottom: '4px' }}>
                                        <span style={{ fontWeight: 'bold', width: '90px' }}>Total GST</span>
                                        <span style={{ fontWeight: 'bold', width: '10px' }}>:</span>
                                        <span style={{ fontStyle: 'italic', textTransform: 'uppercase' }}>{invoiceData.totals.words.toUpperCase()}</span>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <span style={{ fontWeight: 'bold', width: '90px' }}>Bill Amount</span>
                                        <span style={{ fontWeight: 'bold', width: '10px' }}>:</span>
                                        <span style={{ fontStyle: 'italic', textTransform: 'uppercase' }}>{invoiceData.totals.words.toUpperCase()}</span>
                                    </div>
                                </div>
                                {/* Note */}
                                <div style={{ padding: '4px 5px', display: 'flex', fontWeight: 'bold' }}>
                                    <span style={{ width: '40px' }}>Note</span>
                                    <span style={{ width: '10px' }}>:</span>
                                    <span style={{ flex: 1 }}>{data?.remark || ''}</span>
                                </div>
                            </div>

                            {/* Right Half: Taxes */}
                            <div style={{ width: '220px', display: 'flex', flexDirection: 'column', fontSize: '10px' }}>
                                <div style={{ display: 'flex', padding: '4px 8px', justifyContent: 'space-between', fontWeight: 'bold' }}>
                                    <span>Taxable Amount</span>
                                    <span>{invoiceData.totals.taxableAmount}</span>
                                </div>
                                
                                {invoiceData.totals.isLocal ? (
                                    <>
                                        <div style={{ display: 'flex', padding: '2px 8px', justifyContent: 'space-between' }}>
                                            <span>Central Tax <span style={{marginLeft: '10px'}}>{invoiceData.totals.tax1Rate}%</span></span>
                                            <span>{invoiceData.totals.tax1}</span>
                                        </div>
                                        <div style={{ display: 'flex', padding: '2px 8px', justifyContent: 'space-between' }}>
                                            <span>State Tax <span style={{marginLeft: '10px'}}>{invoiceData.totals.tax2Rate}%</span></span>
                                            <span>{invoiceData.totals.tax2}</span>
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ display: 'flex', padding: '2px 8px', justifyContent: 'space-between' }}>
                                        <span>Integrated Tax <span style={{marginLeft: '10px'}}>{parseFloat(invoiceData.totals.tax1Rate) + parseFloat(invoiceData.totals.tax2Rate)}%</span></span>
                                        <span>{invoiceData.totals.totalTax}</span>
                                    </div>
                                )}
                                
                                <div style={{ display: 'flex', padding: '2px 8px', justifyContent: 'space-between', borderBottom: '1.5px solid #000' }}>
                                    <span>Round Off</span>
                                    <span>0.00</span>
                                </div>

                                <div style={{ display: 'flex', padding: '4px 8px', justifyContent: 'space-between', fontWeight: 'bold', backgroundColor: '#d1d5db', fontSize: '11px', flex: 1, alignItems: 'center' }}>
                                    <span>Grand Total</span>
                                    <span>{invoiceData.totals.grandTotal}</span>
                                </div>
                            </div>
                        </div>

                        {/* Signatory & Terms */}
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: 1, padding: '5px', borderRight: '1.5px solid #000' }}>
                                <strong style={{ textTransform: 'uppercase', fontSize: '10px', textDecoration: 'underline' }}>Terms & Condition :</strong>
                                <ol style={{ paddingLeft: '15px', margin: '4px 0 0', fontSize: '9px', lineHeight: '1.3', fontStyle: 'italic' }}>
                                    {(() => {
                                        const termsStr = data?.termsConditions || data?.terms_condition || data?.terms_conditions || '';
                                        if (termsStr && termsStr.trim().length > 0) {
                                            return termsStr.split('\n').map((line, idx) => (
                                                line.trim() ? <li key={idx}>{line.trim()}</li> : null
                                            ));
                                        }
                                        return (
                                            <>
                                                <li>Goods once sold will not be taken back.</li>
                                                <li>Interest @18% p.a. will be charged if payment is not made within due date.</li>
                                                <li>Our risk and responsibility ceases as soon as the goods leave our premises.</li>
                                                <li>"Subject to '{company?.companyCity?.toUpperCase() || 'MORBI'}' Jurisdiction only. E.&O.E"</li>
                                            </>
                                        );
                                    })()}
                                </ol>
                            </div>
                            <div style={{ width: '300px', padding: '5px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '10px' }}>For, {data?.invoiceCompanyName || data?.invoice_company_name || data?.companyName || company?.company_name || 'Inspire Ceramic'}</div>
                                <div className="auth-sign-img" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '5px 0' }}>
                                    {(() => {
                                        const sigImg = company?.company_digital_signature || company?.companyDigitalSignature;
                                        if (sigImg) {
                                            return (
                                                <img
                                                    src={getImageUrl(sigImg)}
                                                    alt="Authorized Signatory"
                                                    crossOrigin="anonymous"
                                                    style={{ maxHeight: '60px', maxWidth: '100%', objectFit: 'contain' }}
                                                />
                                            );
                                        }
                                        return (
                                            <div style={{ width: '60px', height: '60px', border: '1px solid #ccc', position: 'relative' }}>
                                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, border: '1px solid #ccc', transform: 'rotate(45deg)' }}></div>
                                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, border: '1px solid #ccc', transform: 'rotate(-45deg)' }}></div>
                                            </div>
                                        );
                                    })()}
                                </div>
                                <div>
                                    <div style={{ fontWeight: 'bold', fontSize: '10px' }}>(AUTHORISED SIGNATORY)</div>
                                    <div style={{ fontSize: '9px', fontStyle: 'italic' }}>(Authorised Signatory)</div>
                                </div>
                            </div>
                        </div>

                    </div>
                );
            })}
        </div>
    );
};

export default SalesInvoiceFormat8;
